import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="img-delayed-load"
export default class extends Controller {
  static values = {
    url: String
  }

  connect () {
    this.element.addEventListener('load', () => {
      this.dispatch('load')
    })
    this.element.setAttribute('src', this.urlValue)
  }
}
